<mat-form-field [hideRequiredMarker]="hideRequiredMarker" [floatLabel]=floatLabel class="text-area-form-field" [style.width]="size" *ngIf="textArea; else standardInput">
    <mat-label>{{label}}</mat-label>
    <textarea
        [required]="required"
        class="common-ui-text-area-auto-sized"
        libCommonUiComponentsTextInputAutosize
        [minRows]="textAreaMinRows"
        [maxRows]="textAreaMaxRows"
        matInput
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onInputChanged($event)"
        (blur)="onBlur()"
       
        [attr.data-lpignore]="disableLastPass ? 'true' : null"
        [attr.autocomplete]="disableLastPass ? 'new-password' : null">
    </textarea>
</mat-form-field>

<ng-template #standardInput>
    <mat-form-field
        [hideRequiredMarker]="hideRequiredMarker"
        [floatLabel]=floatLabel
        [style.width]="size"
        [style.height]="height"
        [class.custom-bg]="backgroundColor"
        [class.with-border]="showBorder"
        [class.custom-height]="height"
        [style.--custom-bg-color]="backgroundColor"
        [style.--custom-icon-color]="iconColor">
        <mat-label>{{label}}</mat-label>
        <lib-cdw-icon *ngIf="iconPrefix" matPrefix class="icon-prefix" [icon]="iconPrefix"></lib-cdw-icon>
        <input matInput [required]="required" [disabled]="disabled" [readonly]="readonly" [placeholder]="placeholder" [ngModel]="value" (ngModelChange)="onInputChanged($event)" (blur)="onBlur()" [attr.data-lpignore]="disableLastPass ? 'true' : null" [attr.autocomplete]="disableLastPass ? 'new-password' : null">
        <lib-cdw-icon *ngIf="iconSuffix" matSuffix class="text-icon" [icon]="iconSuffix"></lib-cdw-icon>
    </mat-form-field>
</ng-template>
